<div class="border-t-2 flex flex-col gap-4">
    <div class="h-40 bg-tw-lightgrey border-b-2 border-dashed flex justify-around items-center">
        <div class="flex flex-row gap-3 justify-start items-center w-[30%] bg-white p-2">
            <div class="flex h-fit italic font-bold">{{ selection['A'] ? selection['A'].flow : ( 'DOCUMENT_A' | translate) }}</div>
            <div *ngIf="selection['A'] && selection['A'].flow && selection['A'].relecture" class="bg-tw-text-light text-tw-blue border-tw-blue border-[1px] flex flex-row align-middle justify-center w-[2em] h-[2em]">
                <div class="flex leading-[2em]"> {{ getPrefixRelecture(selection['A'].flow).short }}{{ selection['A'].relecture }} </div>
            </div>
            <mat-chip *ngIf="selection['A'] && selection['A'].version !== undefined" class="version-chip-blue">
                {{ 'VERSION_SHORTNAME' | translate }} {{ selection['A'].version }}
            </mat-chip>
        </div>
        <mat-icon svgIcon="compare_arrows"></mat-icon>
        <div class="flex flex-row gap-3 justify-start items-center w-[30%] bg-white p-2">
            <div class="flex h-fit italic font-bold">{{ selection['B'] ? selection['B'].flow : ( 'DOCUMENT_B' | translate) }}</div>
            <div *ngIf="selection['B'] && selection['B'].flow && selection['B'].relecture" class="bg-tw-text-light text-tw-blue border-tw-blue border-[1px] flex flex-row align-middle justify-center w-[2em] h-[2em]">
                <div class="flex leading-[2em]"> {{ getPrefixRelecture(selection['B'].flow).short }}{{ selection['B'].relecture }} </div>
            </div>
            <mat-chip *ngIf="selection['B'] && selection['B'].version !== undefined" class="version-chip-blue">
                {{ 'VERSION_SHORTNAME' | translate }} {{ selection['B'].version }}
            </mat-chip>
        </div>
    </div>
    <div class="p-8">
        <h4 class="py-4">{{ 'SELECT_DOCUMENT_TO_COMPARE' | translate }}</h4>
        <div class="flex justify-between w-full">
            <div class="w-[40%]">
                <p class="italic border-b-2 py-2">{{ 'DOCUMENT_A' | translate }}</p>
                <app-flows-version-selector [mode]="'intern'" [compare]="true" (versionSelected)="selected('A', $event)"></app-flows-version-selector>
            </div>
            <mat-divider vertical></mat-divider>
            <div class="w-[40%]">
                <p class="italic border-b-2 py-2">{{ 'DOCUMENT_B' | translate }}</p>
                <app-flows-version-selector [mode]="'intern'" [compare]="true" (versionSelected)="selected('B', $event)"></app-flows-version-selector>
            </div>
        </div>
    </div>
    <div class="border-t-2 border-dashed p-4">
        <span class="italic text-sm">{{ 'DETAILS' | translate }}</span>
        <div *ngIf="RA || RB || VA || VB" class="flex flex-col justify-between w-full">
            <div *ngIf="RA" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_A' | translate }}</p>
                <app-members-assessments [members]="RA.members" [readonly]="true"></app-members-assessments>
            </div>
            <div *ngIf="VA" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_A' | translate }}</p>
                <app-history-detail [version]="selection['A']"></app-history-detail>
            </div>
            <mat-divider></mat-divider>
            <div *ngIf="RB" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_B' | translate }}</p>
                <app-members-assessments [members]="RB.members" [readonly]="true"></app-members-assessments>
            </div>
            <div *ngIf="VB" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_B' | translate }}</p>
                <app-history-detail [version]="selection['B']"></app-history-detail>
            </div>
        </div>
    </div>
</div>